import { TenantSubscription } from '../../entities/tenant/tenant';
import { BaseSecurityModule } from '../base.security.module';
import { SecurityModuleName } from '../security.module';

/** The Multi-Stage Jobs addon: entitles a tenant to create Multi-Stage jobs. A plan switch only, so it declares no rights. */
export class MultiStageJobsSecurityModule extends BaseSecurityModule<never> {

    constructor() {
        super(SecurityModuleName.MultiStageJobs, []);

        this.plan = TenantSubscription.Custom;
    }

}
